export function generateProgressRatePercentage<T>(
  CANDIDATES_BASE_TO_ENTER_THE_RATE_PROGRESS: Array<T>
) {
  const totalCandidates = CANDIDATES_BASE_TO_ENTER_THE_RATE_PROGRESS.length;

  if (totalCandidates === 0) {
    return 0;
  }
  const candidatesThatAlreadyDone =
    CANDIDATES_BASE_TO_ENTER_THE_RATE_PROGRESS.reduce(
      (acc, current) => (current ? acc + 1 : acc),
      0
    );
  const progressRate =
    candidatesThatAlreadyDone /
    CANDIDATES_BASE_TO_ENTER_THE_RATE_PROGRESS.length;

  return Math.ceil(Number(progressRate.toFixed(2)) * 100);
}
